import { render, staticRenderFns } from "./TwChat.vue?vue&type=template&id=0b9bcb0e&scoped=true&"
import script from "./TwChat.vue?vue&type=script&lang=js&"
export * from "./TwChat.vue?vue&type=script&lang=js&"
import style0 from "./TwChat.vue?vue&type=style&index=0&id=0b9bcb0e&lang=scss&scoped=true&"
import style1 from "./TwChat.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bcb0e",
  null
  
)

export default component.exports